// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PeriodsListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /payroll/periods
 *
 * Lists payroll periods for the franchises in the current filter, with an
 * optional status filter read from the query string.
 */
import { registerContract } from './validate'

export interface Payroll_PeriodsListInput {
status?: string
}

registerContract('Payroll_PeriodsListInput', {
  status: { type: 'string',  required: false },
})
